export enum PasswordRules {
  MINIMUM_AMOUNT = 8,
  MAXIMUM_AMOUNT = 24,
}
